import { render } from "./admin-home.vue?vue&type=template&id=6b5a6a2c&scoped=true"
import script from "./admin-home.vue?vue&type=script&lang=js"
export * from "./admin-home.vue?vue&type=script&lang=js"

import "./admin-home.vue?vue&type=style&index=0&id=6b5a6a2c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b5a6a2c"]])

export default __exports__